import { lazy } from "react";
import Loadable from "../components/Loadable";
import { authRoles } from "../auth/authRoles";

const ManageMembers = Loadable(lazy(() => import("../views/members")));
const MemberDetailPage = Loadable(lazy(() => import("../views/members/MemberDetails")));
const MembersListByOrg = Loadable(lazy(() => import("../views/members/OrgMembers")));

const memberRoutes = [
  { path: "/members", element: <ManageMembers />, auth: authRoles.admin },
  { path: "/members/organisation-members", element: <MembersListByOrg /> },
  { path: "/members/:id", element: <MemberDetailPage />, auth: authRoles.admin },
];

export default memberRoutes;